import { wrapMgt } from '../Mgt';
export const Agenda = wrapMgt('mgt-agenda');
export const FileList = wrapMgt('mgt-file-list');
export const File = wrapMgt('mgt-file');
export const Get = wrapMgt('mgt-get');
export const Login = wrapMgt('mgt-login');
export const PeoplePicker = wrapMgt('mgt-people-picker');
export const People = wrapMgt('mgt-people');
export const PersonCard = wrapMgt('mgt-person-card');
export const Person = wrapMgt('mgt-person');
export const Tasks = wrapMgt('mgt-tasks');
export const TeamsChannelPicker = wrapMgt('mgt-teams-channel-picker');
export const Todo = wrapMgt('mgt-todo');
//# sourceMappingURL=react.js.map